import React from "react";
import { useTranslation } from "react-i18next";
import { events } from "@planzone/events";
import { useNavigate } from "react-router-dom";

import { useMessage } from "@components/useMessage";
import { FillAccount } from "@scenes/fillAccount";
import { Props } from "./types";
import background from "./background.webp";
import styles from "./styles.scss";

function FillAccountPage({ token }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useMessage(
    ({ type }) =>
      type === events.fillAccountSucceeded && navigate("/", { replace: true }),
  );

  return (
    <div
      className={styles.fillAccountPage}
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className={styles.main}>
        <div className={styles.header}>
          <h1 className={styles.title}>{t("fillAccount.title")}</h1>
        </div>
        <div className={styles.form}>
          <FillAccount token={token} />
        </div>
      </div>
    </div>
  );
}

export { FillAccountPage };
